import { createSelector } from 'reselect';
import { trim } from '../../../utilities/trim.esm.js';

function getLockedColumns(allFields) {
  if (!allFields) {
    return [];
  }
  return allFields.filter(function (i) {
    return i.lock === true;
  }).map(function (c) {
    return typeof c.label === 'string' ? trim(c.label) : c.label;
  }).filter(function (s) {
    return s !== undefined;
  }).map(function (s) {
    return s;
  });
}
var createLockedColumnsSelector = function createLockedColumnsSelector() {
  return createSelector(function (props) {
    return props.allFields;
  }, getLockedColumns);
};

export { createLockedColumnsSelector };
//# sourceMappingURL=locked-columns-selector.esm.js.map
